export function* nil() {
  yield null;
}
